import { Component } from '@angular/core';
import { SecuredBaseComponent } from '../base/secured-base.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { WalletService } from '../services/wallet.service';
import { Balance } from '../models/Balance';
import { ManagerService } from '../services/manager.service';

@Component({
  selector: 'crypto-assets-total',
  templateUrl: 'crypto-assets-total.component.html',
  styleUrls: ['crypto-assets-total.component.css']
})
export class CryptoAssetsTotalComponent extends SecuredBaseComponent {

  constructor(public override snackBar: MatSnackBar, public override router: Router, public override managerService: ManagerService,
    private walletService: WalletService)
  {
    super(snackBar, router, managerService);
  }

  walletBalanceChartOptions!: any;
  assets!: Balance[];

  override ngOnInit() {
    super.ngOnInit();

    this.loadAssets();
  }

  loadAssets() {
    this.walletService.balance(this.manager.consumerId).subscribe(
      result => {
        this.assets = result as Balance[];
        this.updateWalletBalanceChart();
      },
      error => { this.showError(error, 'Get crypto assets total has failed due to server error'); }
    );
  }

  updateWalletBalanceChart() {
    this.walletBalanceChartOptions = {
      chart: {
        height: 250,
        type: 'donut'
      },
      legend: {
        position: 'right',
        labels: {
          colors: ['#000000']
        }
      },
      series: this.assets?.map(o => o.amount) || [],
      labels: this.assets?.map(o => o.unit) || [],
      annotations: {
        points: this.assets?.map(o => ({x: o.unit}))
      },
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: true,
              value: {
                show: true
              },
              total: {
                show: false
              }
            }
          }
        }
      },
      dataLabels: {
        enabled: true,
        style: {
          colors: ['#000000']
        },
        dropShadow: {
            enabled: false
        },
        formatter: function(_value: number, { seriesIndex, w }: any) {
          return w.config.annotations.points[seriesIndex].x + ' ' + w.config.series[seriesIndex];
        }
      },
      tooltip: {
        enabled: false
      }
    };
  }
}
